<template>
    <div class="interior-page">
        <Banner v-for="model in data.banners" :model="model" />
        <SmartLinkStandaloneElement :codename="type.elements.content_.codename">
            <div class="content">
                <RichText v-if="!isEmpty(data.content)" :value="data.content" />
            </div>
        </SmartLinkStandaloneElement>
    </div>
    <SocialSharePreviewBlock v-if="page.elements.social_share_preview.value.length > 0" 
                                 :model="pageStore.getLinkedItem<SocialSharePreviewModel>(page.elements.social_share_preview.value[0]!)"/>
</template>

<script lang="ts" setup>
import { contentTypes, type BannerModel, type InteriorPageModel, type SocialSharePreviewModel } from '~~/app/models';

const type = contentTypes.interior_page;

const pageStore = usePageStore();
const page = pageStore.page as InteriorPageModel;

const data = {
    banners:  pageStore.getListAs<BannerModel>(page?.elements?.banner?.value),
    content: page.elements.content_.value
}
const {registerItem} = useAnchorNavBar();
registerItem(page.elements.content_.linkedItemCodenames);
</script>